import { default as OrganizationRailAndPortLocationsModal } from './RailAndPortLocationsModal';

export default OrganizationRailAndPortLocationsModal;
